exports.getIndivDemandes = async (pattern, pagination) => {
  const res = await axios.get(`/demande-indiv`, { params: { pattern: pattern, page: pagination.page }});

  const payload = res && res.data !== undefined ? res.data : res;
  const data = Array.isArray(payload) ? payload : payload?.data ?? payload?.items ?? [];
  const lastPage = payload?.last_page ?? payload?.meta?.last_page ?? 1;

  return { data, last_page: lastPage };
};
